/* eslint-disable */
import Api from '@/services/Api'

export default {
    upload(data){
        try {
            console.log("upload data: ", data);
            return Api().post('wordpress/courses/', data, {headers: {'Content-Type' : 'multipart/form-data'}});
        }catch(err){
            console.log(err);
            return err
        }
    },
}
